import React, { useEffect, useRef, useState } from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { makeStyles } from "@material-ui/core/styles";
import cssClasses from "../../Modals/TimeLineAndNotes/TimeLineAndNotes.module.css";
import { useMediaQuery } from "@mui/material";

import {
  checkIfFVPaymentExists,
  getFVPaymentHistoryByCPpaymentId,
  getSalesManagerName,
} from "../../Services/LeadService";
import Styles from "../../Subcomponents/userCard/userCard.module.css";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
    cursor: "pointer",
  },
  personName: {
    fontFamily: "Inter-SemiBold",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    /* identical to box height, or 150% */

    /* Base/Black */

    color: "#000000",
  },
  id: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.2rem",
    lineheight: "1.8rem",
    /* or 150% */
    /* Gray/500 */
    color: "#667085",
  },
  projects: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: "#344054",
  },
  blockTitle: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: " #667085",
  },
  blockValue: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: "#000000",
    textTransform: "capitalize",
  },
  statusTitle: {
    fontFamily: "Inter-SemiBold",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    /* identical to box height, or 133% */

    /* Gray/900 */

    color: "#101828",
  },
  leadId: {
    fontFamily: "Inter-Regular",
    fonStyle: "normal",
    fonWeight: "400",
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    color: " #667085",
  },
}));
const CPInvoiceDetails = ({ key, invoice, index, data }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const inputStyle = {
    width: isMobile ? "80%" : "100%",
    padding: isMobile ? "0.6rem" : "0.8rem",
    fontSize: "1.4rem",
    border: "1px solid #D0D5DD",
    borderRadius: "6px",
    backgroundColor: "#fff",
    color: "#344054",
  };

  // assuming `invoice` contains required values
  //for downloading invoices
  console.log("cpinvoice data", data);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();
  const classes = useStyles();

  const handleDownload = async (urlPath, fallbackFileName) => {
    const url = `${urlPath}`;
    const fileName = urlPath.split("/").pop() || fallbackFileName;

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  function formatIndianCurrency(amount) {
    if (!amount || isNaN(amount)) return "0";

    const roundedAmount = Math.round(parseFloat(amount)); // Round to nearest integer
    const amountStr = roundedAmount.toString();

    const lastThree = amountStr.substring(amountStr.length - 3);
    const otherNumbers = amountStr.substring(0, amountStr.length - 3);

    const formattedRupees =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      (otherNumbers ? "," : "") +
      lastThree;

    return formattedRupees;
  }

  function formatDate(dateString) {
    if (!dateString) return "NA";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const [salesManagerName, setSalesManagerName] = useState("");

  useEffect(() => {
    const fetchSalesManagerName = async () => {
      const name = await getSalesManagerName(data?.leadData?.leadId);

      setSalesManagerName(name);
    };

    fetchSalesManagerName();
  }, [data]);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [fvPaymentExists, setFvPaymentExists] = useState(false);
  useEffect(() => {
    const fetchFVExists = async () => {
      if (invoice?.invoicesId) {
        const exists = await checkIfFVPaymentExists(invoice?.invoicesId);
        setFvPaymentExists(exists === 1);
      }
    };

    fetchFVExists();
  }, [invoice]);

  //for fvpaymentdetails hitory
  const [showFVModal, setShowFVModal] = useState(false);
  const [fvPaymentData, setFvPaymentData] = useState([]);
  useEffect(() => {
    const FVPaymentData = async () => {
      const FVdata = await getFVPaymentHistoryByCPpaymentId(
        invoice?.invoicesId
      );
      setFvPaymentData(FVdata || []);
    };
    FVPaymentData();
  }, [invoice]);
  const handleViewFVPayment = () => {
    setShowFVModal(true);
  };

  const totalAmount = fvPaymentData.reduce(
    (sum, item) => sum + (Number(item.Amount) || 0),
    0
  );

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "1rem", // optional spacing
        }}
      >
        <LeadStatusChip
          style={{
            color:
              invoice?.FV_Inword_Status === "REJECTED"
                ? "#c01935ff"
                : "#1570EF",
            backgroundColor:
              invoice?.FV_Inword_Status === "REJECTED" ? "#FEF3F2" : "#EFF8FF",
            border: `1px solid ${
              invoice?.FV_Inword_Status === "REJECTED" ? "#FEF3F2" : "#EFF8FF"
            }`,
          }}
          label={invoice?.FV_Inword_Status || ""}
          icon={<Dot width="0.5rem" height="0.5rem" />}
        />
      </div>

      {fvPaymentExists ? (
        <div
          key={index}
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "2rem",
            alignItems: "flex-end",
            borderBottom: "1px solid #E5E7EB",
            paddingBottom: "2rem",
          }}
        >
          {" "}
          {console.log("invoice", invoice)}
          {/* Invoice Number */}
          <div style={{ flex: "1 1 15rem" }}>
            <label style={{ fontSize: "1.4rem", fontWeight: "500" }}>
              Invoice Number
            </label>
            <input
              type="text"
              value={invoice?.Cp_Invoice_Number || "INV-XXXX-XX"}
              readOnly
              style={inputStyle}
            />
          </div>
          {/* Invoice Date */}
          <div style={{ flex: "1 1 15rem" }}>
            <label style={{ fontSize: "1.4rem", fontWeight: "500" }}>
              Invoice Date
            </label>
            <input
              type="text"
              value={formatDate(invoice?.Cp_Invoice_Date)}
              readOnly
              style={inputStyle}
            />
          </div>
          {/* Invoice Amount */}
          <div style={{ flex: "1 1 15rem" }}>
            <label style={{ fontSize: "1.4rem", fontWeight: "500" }}>
              Invoice Amount
            </label>
            <input
              type="text"
              value={
                data?.Net_Brokerage_Amount != null &&
                data?.Brokerage_Amount_TDS != null
                  ? `₹ ${formatIndianCurrency(
                      Number(data.Net_Brokerage_Amount) +
                        Number(data.Brokerage_Amount_TDS)
                    )}`
                  : "₹ 0"
              }
              readOnly
              style={inputStyle}
            />
          </div>
          {/* Paid Amount */}
          <div style={{ flex: "1 1 15rem" }}>
            <label style={{ fontSize: "1.4rem", fontWeight: "500" }}>
              Paid Amount
            </label>
            <input
              type="text"
              value={
                totalAmount ? `₹ ${formatIndianCurrency(totalAmount)}` : "₹ 0"
              }
              readOnly
              style={inputStyle}
            />
            {Number(data?.Brokerage_Amount_Basic || 0) -
              Number(data?.Brokerage_Amount_TDS || 0) ===
              totalAmount && (
              <div
                style={{
                  fontSize: "1.2rem",
                  color: "#1b6b3aff",
                  marginTop: "0.5rem",
                }}
              >
                Basic brokerage paid, GST pending
              </div>
            )}
          </div>
          <div
            style={{ position: "relative", width: "fit-content" }}
            ref={dropdownRef}
          >
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              style={{
                backgroundColor: "#1570EF",
                color: "#fff",
                padding: "0.9rem 1.6rem",
                fontSize: "1.4rem",
                borderRadius: "6px",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: isMobile ? "center" : "flex-start",
                gap: "0.6rem",
                cursor: "pointer",
                width: isMobile ? "150px" : "auto",
              }}
            >
              <FileDownloadOutlinedIcon />
              View Invoices
              <ArrowDropDownIcon />
            </button>

            {showDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "105%",
                  left: 0,
                  backgroundColor: "#1570EF",
                  borderRadius: "15px",
                  height: "max-content",

                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  zIndex: 9999,
                  width: "fit-content",
                }}
              >
                <button
                  onClick={() => {
                    handleDownload(
                      invoice?.System_Invoice_Url,
                      "system-invoice.pdf"
                    );
                    setShowDropdown(false);
                  }}
                  disabled={!invoice?.System_Invoice_Url}
                  style={{
                    width: "100%",
                    padding: "1rem",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "black",
                    backgroundColor: invoice?.System_Invoice_Url
                      ? "white"
                      : "#a0aec0",
                    border: "none",
                    textAlign: "left",
                    cursor: invoice?.System_Invoice_Url
                      ? "pointer"
                      : "not-allowed",
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  System Invoice
                </button>
                <button
                  onClick={() => {
                    handleDownload(invoice?.Cp_Invoice_Url, "cp-invoice.pdf");
                    setShowDropdown(false);
                  }}
                  disabled={!invoice?.Cp_Invoice_Url}
                  style={{
                    width: "100%",
                    padding: "1rem",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "black",
                    backgroundColor: invoice?.Cp_Invoice_Url
                      ? "white"
                      : "#a0aec0",
                    border: "none",
                    textAlign: "left",
                    cursor: invoice?.Cp_Invoice_Url ? "pointer" : "not-allowed",
                  }}
                >
                  CP Invoice
                </button>
              </div>
            )}
          </div>
          {/* View Payments Button */}
          <div style={{ flex: "1 1 15rem" }}>
            <button
              style={{
                backgroundColor: "#2D5BE3",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "0.8rem 1.6rem",
                fontSize: "1.4rem",
                width: "100%",
                cursor: "pointer",
              }}
              onClick={handleViewFVPayment}
            >
              View Payments
            </button>
          </div>
          {/* Rejected Reason */}
          {invoice?.FV_Inword_Status === "REJECTED" && (
            <div
              style={{
                flex: "1 1 100%",
                fontSize: "1.4rem",
                color: "#c01935ff",
                marginTop: "1rem",
              }}
            >
              <span
                style={{
                  backgroundColor: "#FEF3F2",
                  padding: "0.4rem 0.8rem",
                  borderRadius: "6px",
                  marginRight: "0.6rem",
                  display: "inline-block",
                }}
              >
                Rejected Reason:
              </span>
              {invoice.Reject_Note}
            </div>
          )}
        </div>
      ) : (
        <div
          key={index}
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "2rem",
            alignItems: "flex-end",
            borderBottom: "1px solid #E5E7EB",
            paddingBottom: "2rem",
          }}
        >
          {" "}
          {console.log("invoice", invoice)}
          {/* Invoice Number */}
          <div style={{ flex: "1 1 15rem" }}>
            <label style={{ fontSize: "1.4rem", fontWeight: "500" }}>
              Invoice Number
            </label>
            <input
              type="text"
              value={invoice?.Cp_Invoice_Number || "INV-XXXX-XX"}
              readOnly
              style={inputStyle}
            />
          </div>
          {/* Invoice Date */}
          <div style={{ flex: "1 1 15rem" }}>
            <label style={{ fontSize: "1.4rem", fontWeight: "500" }}>
              Invoice Date
            </label>
            <input
              type="text"
              value={formatDate(invoice?.Cp_Invoice_Date)}
              readOnly
              style={inputStyle}
            />
          </div>
          {/* Invoice Amount */}
          <div style={{ flex: "1 1 15rem" }}>
            <label style={{ fontSize: "1.4rem", fontWeight: "500" }}>
              Invoice Amount
            </label>
            <input
              type="text"
              value={
                data?.Net_Brokerage_Amount != null &&
                data?.Brokerage_Amount_TDS != null
                  ? `₹ ${formatIndianCurrency(
                      Number(data.Net_Brokerage_Amount) +
                        Number(data.Brokerage_Amount_TDS)
                    )}`
                  : "₹ 0"
              }
              readOnly
              style={inputStyle}
            />
          </div>
          {/* Paid Amount */}
          <div style={{ flex: "1 1 15rem" }}>
            <label style={{ fontSize: "1.4rem", fontWeight: "500" }}>
              Paid Amount
            </label>
            <input
              type="text"
              value={
                totalAmount ? `₹ ${formatIndianCurrency(totalAmount)}` : "₹ 0"
              }
              readOnly
              style={inputStyle}
            />
            {Number(data?.Brokerage_Amount_Basic || 0) -
              Number(data?.Brokerage_Amount_TDS || 0) ===
              totalAmount && (
              <div
                style={{
                  fontSize: "1.2rem",
                  color: "#1b6b3aff",
                  marginTop: "0.5rem",
                }}
              >
                Basic brokerage paid, GST pending
              </div>
            )}
          </div>
          <div
            style={{ position: "relative", width: "fit-content" }}
            ref={dropdownRef}
          >
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              style={{
                backgroundColor: "#1570EF",
                color: "#fff",
                padding: "0.9rem 1.6rem",
                fontSize: "1.4rem",
                borderRadius: "6px",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: isMobile ? "center" : "flex-start",
                gap: "0.6rem",
                cursor: "pointer",
                width: isMobile ? "150px" : "auto",
              }}
            >
              <FileDownloadOutlinedIcon />
              View Invoices
              <ArrowDropDownIcon />
            </button>

            {showDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "105%",
                  left: 0,
                  backgroundColor: "#1570EF",
                  borderRadius: "15px",
                  height: "max-content",

                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  zIndex: 9999,
                  width: "fit-content",
                }}
              >
                <button
                  onClick={() => {
                    handleDownload(
                      invoice?.System_Invoice_Url,
                      "system-invoice.pdf"
                    );
                    setShowDropdown(false);
                  }}
                  disabled={!invoice?.System_Invoice_Url}
                  style={{
                    width: "100%",
                    padding: "1rem",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "white",
                    backgroundColor: invoice?.System_Invoice_Url
                      ? "#8cbafaff"
                      : "#a0aec0",
                    border: "none",
                    textAlign: "left",
                    cursor: invoice?.System_Invoice_Url
                      ? "pointer"
                      : "not-allowed",
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  📄 System Invoice
                </button>
                <button
                  onClick={() => {
                    handleDownload(invoice?.Cp_Invoice_Url, "cp-invoice.pdf");
                    setShowDropdown(false);
                  }}
                  disabled={!invoice?.Cp_Invoice_Url}
                  style={{
                    width: "100%",
                    padding: "1rem",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "white",
                    backgroundColor: invoice?.Cp_Invoice_Url
                      ? "#8cbafaff"
                      : "#a0aec0",
                    border: "white",
                    textAlign: "left",
                    cursor: invoice?.Cp_Invoice_Url ? "pointer" : "not-allowed",
                  }}
                >
                  📄 CP Invoice
                </button>
              </div>
            )}
          </div>
          {/* View Payments Button */}
          <div style={{ flex: "1 1 15rem" }}>
            <button
              style={{
                backgroundColor: "#9a9fadff",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "0.8rem 1.6rem",
                fontSize: "1.4rem",
                width: "100%",
                cursor: "not-allowed",
                opacity: fvPaymentExists === 0 ? 0.6 : 1, // visual cue for disabled
              }}
              disabled={fvPaymentExists === 0}
              onClick={() => {
                console.log("View Payments for", invoice);
              }}
            >
              View Payments
            </button>
          </div>
          {/* Rejected Reason */}
          {invoice?.FV_Inword_Status === "REJECTED" && (
            <div
              style={{
                flex: "1 1 100%",
                fontSize: "1.4rem",
                color: "#c01935ff",
                marginTop: "1rem",
              }}
            >
              <span
                style={{
                  backgroundColor: "#FEF3F2",
                  padding: "0.4rem 0.8rem",
                  borderRadius: "6px",
                  marginRight: "0.6rem",
                  display: "inline-block",
                }}
              >
                Rejected Reason:
              </span>
              {invoice.Reject_Note}
            </div>
          )}
        </div>
      )}
      {showFVModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            padding: 7,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2rem",
              borderRadius: "10px",
              maxHeight: "80vh",
              overflowY: "auto",
              minWidth: "60%",
            }}
          >
            <div className={cssClasses.header}>
              <div className={cssClasses.headerTitle}>
                <div>Payment Details</div>
              </div>
            </div>

            <div
              className={cssClasses.wrapperFirstRow}
              style={{ marginTop: "2rem", marginBottom: "3rem" }}
            >
              <div className={cssClasses.wrapperNameProjects}>
                <div className={cssClasses.block}>
                  <span className={classes.personName}>
                    {data.personData?.name}
                  </span>
                  <div className={classes.leadId}>
                    {"VJ" +
                      data?.leadData?.leadDisplayId?.replace(
                        data?.leadData?.leadDisplayId?.substring(8, 12),
                        "-" + data?.leadData?.leadDisplayId?.substring(8, 12)
                      )}
                  </div>
                </div>
                <div className={cssClasses.block}>
                  <div className={classes.projects}>
                    {data.projectData?.projectName} |{" "}
                    {data.inventoryDataForLead?.unitNo}
                  </div>
                </div>
              </div>
              <div className={cssClasses.wrapperNames}>
                <div className={cssClasses.block}>
                  <div className={classes.blockTitle}>CP:</div>
                  <div className={classes.blockValue}>
                    {data.CP_Ladger_Name ?? "-"}
                  </div>
                </div>
                <div className={cssClasses.block}>
                  <div className={classes.blockTitle}>FoS :</div>
                  <div className={classes.blockValue}>
                    {data.fosData?.name ?? "-"}
                  </div>
                </div>
                <div className={cssClasses.block}>
                  <div className={classes.blockTitle}>
                    Sales Representative :
                  </div>
                  <div className={classes.blockValue}>
                    {salesManagerName ?? "-"}
                  </div>
                </div>
              </div>
            </div>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "1.4rem",
              }}
            >
              <thead>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "1rem" }}>
                    Invoice Number
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "1rem" }}>
                    Payment UTR
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "1rem" }}>
                    Paid Amount
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "1rem" }}>
                    Payment Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {fvPaymentData.map((item, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        border: "1px solid #ccc",
                        padding: "1rem",
                        textAlign: "center",
                      }}
                    >
                      {item.FVInvoiceNumber}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ccc",
                        padding: "1rem",
                        textAlign: "center",
                      }}
                    >
                      {item.UTR}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ccc",
                        padding: "1rem",
                        textAlign: "center",
                      }}
                    >
                      {item?.Amount
                        ? `₹ ${formatIndianCurrency(item.Amount)}`
                        : "₹ 0"}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ccc",
                        padding: "1rem",
                        textAlign: "center",
                      }}
                    >
                      {" "}
                      {item.FV_payment_Date
                        ? formatDate(item.FV_payment_Date)
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div style={{ textAlign: "right", marginTop: "1.5rem" }}>
              <button
                onClick={() => setShowFVModal(false)}
                style={{
                  padding: "0.8rem 1.6rem",
                  backgroundColor: "#1570EF",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "1.4rem",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CPInvoiceDetails;
